import { z } from 'zod';

export const CurateHostSchema = z.object({
  isCurated: z.boolean(),
});

export enum HostStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
